import { download, previewPdf, previewOffice } from './utils/file'

export interface PluginConfig {
  download: (name: string, url: string) => void;
  previewPdf: (url: string) => void;
  previewOffice: (url: string) => void;
}

const config: PluginConfig = {
  download,
  previewPdf,
  previewOffice
}

export default config
